module.exports = __webpack_public_path__ + "48b400d5e71a93a3cf034969fd9f18b1.png";